// Currency-aware price formatter for components that already expose a
// `currentCurrency` computed (typically via currencyRouteMixin).
//
// Differs from the global `formatPrice` filter (src/filters.js):
// - reads currency from the component (route-driven), not the global store
// - uses `narrowSymbol` so the table layout stays compact (€, £ instead of EUR/GBP)
export default {
  methods: {
    formatPriceFromCents(cents) {
      if (typeof cents !== "number") return "";
      const locale = this.$i18n?.locale || "fr-FR";
      const currency =
        this.currentCurrency?.toLowerCase() === "euro"
          ? "EUR"
          : (this.currentCurrency || "EUR").toUpperCase();
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
        currencyDisplay: "narrowSymbol",
      }).format(cents / 100);
    },
  },
};
